export default __webpack_public_path__ + "static/media/arrow_down.f5e093ce.svg";